<template>
  <ReviewCategoriesChartWrapper
    :is-loading="isLoading"
    @get-chart-data="getChartData"
  >
    <template v-slot:filters>
      <v-switch
        v-for="(filter, index) in sentimentFilters"
        :key="index"
        v-model="filter.value"
        :label="filter.label"
        :color="filter.color"
        hide-details
        inset
        class="mt-0"
      />
    </template>
    <template v-slot:chart>
      <BarChart
        :data="chartData"
        :labels="chartLabels"
        :selected-category="selectedCategory"
      />
    </template>
  </ReviewCategoriesChartWrapper>
</template>

<script>
import BarChart from "@/components/Reviews/Categories/BarChart";
import { REVIEWS_DATA_PERIOD } from "@/enums/reviews-data-period.enum";
import ReviewCategoriesChartWrapper from "@/components/Reviews/Categories/ReviewsCategoriesChartWrapper.vue";
import { ReviewCategoriesChartMixin } from "@/helpers/mixins/review-categories-chart";
import { SENTIMENT_COLOR } from "@/config/sentiment-colors.js";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
export default {
  name: "ReviewsCategoriesBarChart",
  components: {
    BarChart,
    ReviewCategoriesChartWrapper
  },
  mixins: [ReviewCategoriesChartMixin],
  data() {
    return {
      REVIEWS_DATA_PERIOD,
      chartFilter: REVIEWS_DATA_PERIOD.WEEK,
      chartData: {
        basic: [],
        comparison: [],
        tooltip: {
          basic: [],
          comparison: []
        }
      },
      chartApiData: { basic: [], comparison: [] },
      chartLabels: [],
      sentimentFilters: {
        negative: {
          color: SENTIMENT_COLOR.NEGATIVE,
          label: this.$t("message.sentiment.negative"),
          event_action_name: "show_negative",
          value: true
        },
        neutral: {
          color: SENTIMENT_COLOR.NEUTRAL,
          label: this.$t("message.sentiment.neutral"),
          event_action_name: "show_neutral",
          value: true
        },
        positive: {
          color: SENTIMENT_COLOR.POSITIVE,
          label: this.$t("message.sentiment.positive"),
          event_action_name: "show_positive",
          value: true
        },
        unassigned: {
          color: SENTIMENT_COLOR.UNASSIGNED,
          label: this.$t("message.sentiment.unassigned"),
          event_action_name: "show_unknown",
          value: true
        }
      }
    };
  },

  methods: {
    mapSentimentData(item) {
      return [
        this.sentimentFilters.negative.value
          ? item.sentiment_negative
          : undefined,
        this.sentimentFilters.neutral.value
          ? item.sentiment_neutral
          : undefined,
        this.sentimentFilters.positive.value
          ? item.sentiment_positive
          : undefined,
        this.sentimentFilters.unassigned.value
          ? item.sentiment_unassigned
          : undefined
      ];
    },
    async getChartData(view) {
      this.isLoading = true;
      this.chartFilter = view;
      const { basic, comparison } = await this.fetchMethod({
        view
      });
      this.chartApiData = { basic, comparison };

      this.formatData();
      this.isLoading = false;
    },
    formatData() {
      this.chartData.basic = this.chartApiData.basic.map(this.mapSentimentData);

      this.chartData.tooltip.basic = this.chartApiData.basic.map(
        ({ count, sentiment }) => ({ count, sentiment })
      );

      this.chartData.comparison = this.chartApiData.comparison.length
        ? this.chartApiData.comparison.map(this.mapSentimentData)
        : this.chartApiData.comparison;

      if (this.chartApiData.comparison.length) {
        this.chartData.tooltip.comparison = this.chartApiData.comparison.map(
          ({ count, sentiment }) => ({ count, sentiment })
        );
      }

      this.chartLabels = this.getChartLabels(
        this.chartApiData.basic,
        this.chartApiData.comparison
      );
    }
  },

  watch: {
    sentimentFilters: {
      handler(current) {
        const eventActions = Object.entries(current).reduce(
          (acc, [key, { event_action_name, value }]) => {
            acc[event_action_name] = value;
            return acc;
          },
          {}
        );
        this.$gtm.trackCustomEvent({
          event:
            GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_DETAILS_CHART_SENTIMENT_DETAILS_CONFIG_CHANGE,
          ...eventActions
        });
        this.formatData();
      },
      deep: true
    }
  }
};
</script>
